export default __webpack_public_path__ + "static/media/logo-trustpilot-3-5-stars.088268ef.svg";